import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styles: [],
    standalone: false
})
export class Page404Component implements OnInit {
  ngOnInit(): void {}

  goHome(){
    window.location.replace('')
  }
}
